import {
    combineReducers
} from "@reduxjs/toolkit";

import APIKeyslice from "./apiKey/reducer"

import TodoReducer from "./todo/reducer"

import Contactslice from "./contact/reducer"

import EmailReducer from "./email/reducer"

import chatReducer from "./chat/reducer";

import TasksReducer from "./kanban/reducer"

import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import BusinessInfoReducer from './businessInfo/reducer'
import WorksReducer from './works/reducer'
import CatalogueReducer from './catalog/reducer'
import MobCatalogReducer from './mobCatalog/reducer'
import DashboardReducer from './dashboard/reducer'
import MobileViewReducer from './mobile-view/reducer'
import MobileViewListing from './mobile-view-listing/reducer.js'
import MobileViewWork from './mobile-view/reducer.js'
import LiveAds from './ads/reducer.js'
import AllAds from './ads/reducer.js'
import AdPlans from './ads/reducer.js'
import adAnalyticsReducer from './adsAnalytics/reducer.js';
import NotificationData from './notification/reducer.js'
import TransactionData from './transaction/reducer.js'
import NotificationAll from './notificationAll/reducer.js'
import duplicateReducer from './DuplicateAd/reducer.js'
import GlobalReloadReducer from "./globalReload.js";
// import authReducer from "./auth/login/reducer"

const rootReducer = combineReducers({
    APIKey: APIKeyslice,
    Contacts: Contactslice,
    Todo: TodoReducer,
    Email: EmailReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    Profile: ProfileReducer,
    ForgetPassword: ForgetPasswordReducer,
    Chat: chatReducer,
    Tasks: TasksReducer,
    BusinessInfoReducer: BusinessInfoReducer,
    Dashboard: DashboardReducer,
    Works: WorksReducer,
    Catalog: CatalogueReducer,
    mobCatalog: MobCatalogReducer,
    MobileViewDashboard: MobileViewReducer,
    MobileViewListing: MobileViewListing,
    MobileViewWork: MobileViewWork,
    LiveAds: LiveAds,
    AllAds: AllAds,
    AdPlans: AdPlans,
    AdAnalytics : adAnalyticsReducer,
    Notification: NotificationData,
    NotificationAll: NotificationAll,
    Transaction: TransactionData,
    DuplicateAd: duplicateReducer,
    GlobalReload:GlobalReloadReducer
});

export default rootReducer